export default __webpack_public_path__ + "static/media/laptop.41e04e03.png";